const CallSubmissionFormTitle = () => {
  return (
    <div
      style={{
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.08)',
      }}
      className="border-none bg-[#F7F7F7]"
    >
      <div className="bg-[#F7F7F7] px-8 py-1.5">
        <p className="text-title">ثبت تماس جدید</p>
      </div>
    </div>
  )
}

export default CallSubmissionFormTitle
